module.exports = __webpack_public_path__ + "static/media/images-el_img1.66f52b9b.jpg";